import pluralize from 'pluralize'
import {SkeletonText} from '@primer/react/experimental'
import {useIsLoading} from '../contexts/IsLoadingContext'
import {useCounts} from '../contexts/CountsContext'

export function PreviewsCountSummary() {
  const isLoading = useIsLoading()
  const {numberOfEnabledRulesets, numberOfEnabledPreviews} = useCounts()

  if (isLoading) {
    return <SkeletonText />
  }

  return (
    <span>
      {numberOfEnabledRulesets} {pluralize('ruleset', numberOfEnabledRulesets)}{' '}
      <span>
        will be created from {numberOfEnabledPreviews} branch protection {pluralize('rule', numberOfEnabledPreviews)}.
      </span>
    </span>
  )
}
